// Firebase project used ONLY for the "Premiums Config" admin lock
// (see src/context/AdminAuthContext.jsx). This is a separate Firebase
// project/account from the main app (src/utils/firebase.js), which is
// why it gets its own initializeApp() call here.
//
// Config comes from the VITE_ADMIN_FIREBASE_* environment variables
// (see .env.example). Firebase Console → Project settings → Your apps →
// SDK setup and configuration.
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const adminFirebaseConfig = {
  apiKey:            import.meta.env.VITE_ADMIN_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_ADMIN_FIREBASE_AUTH_DOMAIN,
  databaseURL:       import.meta.env.VITE_ADMIN_FIREBASE_DATABASE_URL,
  projectId:         import.meta.env.VITE_ADMIN_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_ADMIN_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_ADMIN_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_ADMIN_FIREBASE_APP_ID,
};

const missingAdminKeys = Object.entries(adminFirebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);
if (missingAdminKeys.length > 0) {
  console.error(
    "[adminFirebase] Missing environment variables for: " + missingAdminKeys.join(", ") +
    ". Fill in the VITE_ADMIN_FIREBASE_* values in .env and restart / rebuild."
  );
}

// Named (non-default) app instance so this doesn't collide with the
// main app's initializeApp() call, which uses the default app name.
const adminApp = initializeApp(adminFirebaseConfig, "adminAuthApp");

export const adminAuth = getAuth(adminApp);
